import { Component } from 'react';
import { connect } from 'react-redux';
import ImportExportView from '../../components/import-export-view/ImportExportView.jsx';

class ImportExport extends Component {
    render() {
        return <ImportExportView />;
    }
}

export default connect()(ImportExport);
